import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './Hospitality.css';

const Hospitality = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Hospitality Services | Digi Network" 
                description="Learn more about our Hospitality services to grow your business online with Digi Network." 
                canonical="/industries/hospitality/hospitality" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">Hospitality Industry</div>
                        <h1>Digital Marketing for Hospitality</h1>
                        <p>Fill rooms, tables, and events with targeted digital marketing strategies designed for restaurants, hotels, and hospitality businesses. We understand the unique challenges hospitality businesses face in today's competitive market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add Hospitality Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>Hospitality Marketing Services</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for hospitality businesses</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Hospitality SEO</h3>
                            <p>Rank for local searches, attract diners and guests, and build authority in your area. Our hospitality SEO strategies help restaurants and hotels dominate local search results and attract qualified customers.</p>
                            <ul>
                                <li>Local SEO for restaurants & hotels</li>
                                <li>Google My Business optimization</li>
                                <li>Menu & amenity optimization</li>
                                <li>Review management</li>
                                <li>Hospitality directory listings</li>
                                <li>Event page optimization</li>
                            </ul>
                            <Link to="/industries/hospitality/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Hospitality Paid Ads</h3>
                            <p>Drive reservations and bookings with targeted advertising campaigns that showcase your offerings. Our targeted ad campaigns reach people actively looking for dining and accommodation options.</p>
                            <ul>
                                <li>Google Ads for hospitality</li>
                                <li>Facebook & Instagram ads</li>
                                <li>Promotion & special offers</li>
                                <li>Event marketing campaigns</li>
                                <li>Retargeting strategies</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/hospitality/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Hospitality Website Design</h3>
                            <p>Beautiful hospitality websites with online reservations, menus, and virtual tours. Our hospitality websites are designed to showcase your offerings and make it easy for guests to book.</p>
                            <ul>
                                <li>Restaurant & hotel websites</li>
                                <li>Online reservation systems</li>
                                <li>Menu & gallery displays</li>
                                <li>Event booking platforms</li>
                                <li>Mobile-responsive design</li>
                                <li>Virtual tour integration</li>
                            </ul>
                            <Link to="/industries/hospitality/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Hospitality Email Marketing</h3>
                            <p>Engage guests with special offers, event invitations, and loyalty programs. Build lasting relationships with guests through strategic email communication that provides value.</p>
                            <ul>
                                <li>Promotional email campaigns</li>
                                <li>Event invitation emails</li>
                                <li>Loyalty program communications</li>
                                <li>Seasonal special offers</li>
                                <li>Guest feedback campaigns</li>
                                <li>Win-back campaigns</li>
                            </ul>
                            <Link to="/industries/hospitality/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Hospitality CRM & Automation</h3>
                            <p>Manage guests, automate communications, and track bookings with GoHighLevel. Streamline your guest management and communication workflows to improve satisfaction.</p>
                            <ul>
                                <li>Guest relationship management</li>
                                <li>Reservation confirmations</li>
                                <li>Automated follow-ups</li>
                                <li>Loyalty program automation</li>
                                <li>Guest feedback tracking</li>
                                <li>Event management automation</li>
                            </ul>
                            <Link to="/industries/hospitality/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title">Our Hospitality Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for hospitality businesses</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Business Analysis</h3>
                            <p>We analyze your hospitality business, target audience, and competitive landscape to understand your unique positioning. Our team conducts comprehensive audits of your current marketing and guest acquisition strategies.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Booking-Focused Strategy</h3>
                            <p>We develop a customized marketing strategy that focuses on driving reservations and bookings. Every tactic is designed to fill your rooms and tables with qualified guests.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Multi-Channel Implementation</h3>
                            <p>We implement the marketing strategy across all channels, from SEO to social media to email. Our team handles everything from content creation to ad campaign launches.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Guest Retention & Growth</h3>
                            <p>We continuously monitor performance, analyze guest feedback, and optimize campaigns for better results. Regular reporting keeps you informed of your booking rates and guest satisfaction metrics.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Hospitality Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why Hospitality Businesses Choose Digi Network</h2>
                    <p className="why-intro">Trusted by hospitality professionals across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Booking-Focused</h3>
                            <p>Every strategy is designed to drive reservations and bookings, filling your rooms and tables. We understand that hospitality success is measured in occupancy and covers, not just website traffic.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Hospitality Expertise</h3>
                            <p>We understand the hospitality industry and create campaigns that attract guests and diners. Our team has extensive experience working with restaurants, hotels, and event venues.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Local Market Focus</h3>
                            <p>We target local customers who are ready to book, dine, or attend events. Our strategies focus on converting interested prospects into paying guests.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Proven Results</h3>
                            <p>We've helped hospitality businesses increase bookings by 300%+ through targeted marketing. Our data-driven approach delivers measurable results that directly impact your bottom line.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for Hospitality Businesses</h2>
                    <p className="section-intro">How our marketing services help you grow your hospitality business</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More Bookings</h3>
                            <p>Generate more reservations and bookings through targeted marketing campaigns. Our strategies focus on converting interested prospects into paying guests.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Online Visibility</h3>
                            <p>Dominate local search results for dining and accommodation options. When potential guests search for your services, they'll find your business first.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Improved Guest Loyalty</h3>
                            <p>Build lasting relationships with guests through email marketing and loyalty programs. Turn first-time guests into repeat customers and brand advocates.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Increased Event Bookings</h3>
                            <p>Drive more event bookings through targeted campaigns and automated follow-ups. Fill your event calendar and maximize your event revenue.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Higher Revenue</h3>
                            <p>Increase revenue through more bookings, higher occupancy rates, and better retention. Our strategies help you maximize every aspect of your hospitality business.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many hospitality businesses still rely on basic marketing methods.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Hospitality Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Fill Your Rooms & Tables?</h2>
                    <p>Let's discuss how we can help you attract more guests and grow your hospitality business.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Hospitality;
